import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ReturnRequestCorporate } from '../model/ReturnRequestCorporate';
import { ReturnRequestCorpDto } from '../model/dto/ReturnRequestCorpDto';
import { ReturnRequestCorporateDet } from '../model/ReturnRequestCorporateDet';
import { ReturnReqCorpRejected } from '../model/ReturnReqCorpRejected';

@Injectable()
export class ReturnRequestCorporateFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetCollection(parameters : any): Observable<RequestResponse<ReturnRequestCorporate[]>> {
        let body = JSON.stringify(parameters)
    
        return this._httpClient.post<RequestResponse<ReturnRequestCorporate[]>>(this._urlBase + 'api/ReturnRequestCorporate/Collection', body, {
            headers: new HttpHeaders({'Content-Type':  'application/json'})
        })
    }

    CreateWithValidation(request: ReturnRequestCorpDto): Observable<RequestResponse<number>> {
        let body = JSON.stringify(request);
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/ReturnRequestCorporate/CreateWithValidation', body, {
            headers: new HttpHeaders({'Content-Type':  'application/json'})
        })
    }

    GetDetail(returnReqCorporateId : Number): Observable<RequestResponse<ReturnRequestCorporateDet[]>> {
        return this._httpClient.get<RequestResponse<ReturnRequestCorporateDet[]>>(this._urlBase + 'api/ReturnRequestCorporate/Detail?returnReqCorporateId='+returnReqCorporateId);
    }

    GetRejectedList(returnReqCorporateId : Number): Observable<RequestResponse<ReturnReqCorpRejected[]>> {
        return this._httpClient.get<RequestResponse<ReturnReqCorpRejected[]>>(this._urlBase + 'api/ReturnRequestCorporate/GetRejectedList?returnReqCorporateId='+returnReqCorporateId);
    }
}
